<template>
    <Combobox as="div" v-model="selectedOption">
        <span class="text-won-blue font-bold" :class="placeholderClasses" v-if="showPlaceholder">
        {{ placeholder }} <span v-if="required" class="text-[#CE2020]">*</span>
        </span>

        <div class="relative mt-2">
            <ComboboxInput
                :class="[inputStyle, 'h-9 cursor-pointer']"
                @change="query = $event.target.value"
                :display-value="(option) => option"
            />

            <ComboboxButton
                class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
            >
                <ChevronUpDownIcon
                    class="w-5 h-5 text-gray-400"
                    aria-hidden="true"
                />
            </ComboboxButton>

            <ComboboxOptions
                v-if="filteredOptions.length > 0"
                class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            >
                <ComboboxOption
                    v-for="option in filteredOptions"
                    :key="option"
                    :value="option"
                    as="template"
                    v-slot="{ active, selected }"
                >
                    <li
                        class="cursor-default select-none relative py-2 pl-10 pr-4"
                        :class="{
                            'text-white won-green-button-color': active,
                            'text-gray-900': !active,
                        }"
                    >
                <span
                    class="block truncate"
                    :class="{ 'font-medium': selected, 'font-normal': !selected }"
                    :v-html="option"
                >
                  {{ option }}
                </span>
                        <span
                            v-if="selected"
                            class="absolute inset-y-0 left-0 flex items-center pl-3"
                            :class="{ 'text-white': active, 'won-green-text-color': !active }"
                        >
                  <CheckIcon class="w-5 h-5" aria-hidden="true"/>
                </span>
                    </li>
                </ComboboxOption>
            </ComboboxOptions>
            <ComboboxOptions v-else
                             class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                <ComboboxOption :value="'Other'">
                    <li
                        class="cursor-default select-none relative py-2 pl-10 pr-4"
                    >
                <span
                    class="block truncate"
                >
                  Other
                </span>
                    </li>
                </ComboboxOption>
            </ComboboxOptions>
        </div>
    </Combobox>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import {
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxOption,
    ComboboxOptions,
} from '@headlessui/vue'
import {CheckIcon, ChevronUpDownIcon} from "@heroicons/vue/24/solid";
import { inputStyle } from "../../utils/styles";

const correctInputStyles = "font-[Inter] appearance-none block w-full px-3 py-2.5 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:border focus:border-transparent focus:ring-1 focus:ring-green-800 sm:text-sm overflow-hidden"

const emit = defineEmits(['value-change']);
const props = defineProps({
    options: {
        type: Object,
        required: true
    },
    placeholder: {
        type: String,
        default: ""
    },
    placeholderClasses: {
        type: String,
        default: "text-[12px] leading-[20px]"
    },
    required: {
        type: Boolean,
        default: false
    },
    showPlaceholder: {
        type: Boolean,
        default: true
    }
})

const query = ref('')
const selectedOption = ref(null)
const filteredOptions = computed(() =>
    query.value === ''
        ? props.options
        : props.options.filter(option =>
            option.toLowerCase().includes(query.value.toLowerCase())
        )
);
watch(selectedOption, (newValue) => emit('value-change', newValue))
</script>
